<template>
  <div class="menubar-goals">
    <div class="menubar-heading">
      <router-link to="/goals" class="clickable">
        My goals
      </router-link>
      <font-awesome-icon
        @click="onClickChevron"
        icon="chevron-down"
        :class="{
          'is-active': collapsed
        }" />
    </div>

    <transition name="fade">
      <div v-if="!collapsed">

        <div class="menu-no-content" v-if="menu_goal_list.length === 0">
          <p>
            You don't have any goals yet.<br />
            Get started by adding your
            <a href="#" @click.prevent="onAddGoal">first goal</a>.
          </p>
        </div>

        <template v-if="show_all">
          <div
            v-for="category in categories"
            v-if="$ready_goals"
            :key="category.$key">

            <h6 class="menubar-goal-category">{{category.name}}</h6>

            <InlineGoalMenubar
              v-for="goal_item in menu_goal_list"
              v-if="goal_item.category_id === category.$id"
              :key="goal_item.goal_id"
              :goal-id="goal_item.goal_id"
              :selected="goal_item.selected"
              @select="onGoToGoal"
              class="menubar-goal-item" />
          </div>

          <div @click="onAddGoal" class="menu-add-button clickable">
            <font-awesome-icon :icon="['far', 'plus-circle']" />
            <div class="menu-add-button__text">Create a new goal</div>
          </div>

          <a href="#" class="menubar-link" @click.prevent="show_all = false">show only favorites</a>
        </template>

        <template v-else>
          <InlineGoalMenubar
            v-for="goal_item in menu_goal_list"
            v-if="goal_item.is_favorite"
            :key="goal_item.goal_id"
            :goal-id="goal_item.goal_id"
            :selected="goal_item.selected"
            @select="onGoToGoal"
            class="menubar-goal-item" />

          <div @click="onAddGoal" class="menu-add-button clickable">
            <font-awesome-icon :icon="['far', 'plus-circle']" />
            <div class="menu-add-button__text">Create a new goal</div>
          </div>

          <a href="#" class="menubar-link" @click.prevent="show_all = true">show all</a>
        </template>

        <!-- <pre class="mini-pre text-white">{{menu_goal_list}}</pre> -->
      </div>
    </transition>

  </div>
</template>

<script>
import { mapReady } from "@/api/misc";
import InlineGoalMenubar from '@/components/Inline/InlineGoalMenubar.vue'

// xTOOD: clap line "..."
// xTOOD: Placeholder, when no goals exists
// xTODO: Group by goal category in extended mode

// TODO: Save collapse state in cookie

export default {
  data: () => ({
    collapsed: false,
    show_all: false,
  }),
  computed: {
    ...mapReady('goals'),

    categories() {
      let categories = this.$models.userGoalCategory.subscribeList().itemsSorted;
      categories.push({ $id: null, $key: 'unassigned', name: 'No category' })
      return categories;
    },

    active_goal() {
      return this.$route.params.goalId || null
    },

    menu_goal_list() {
      const menu_goal_list = []
      if ( this.user_goal_settings.$readyAll ) {
        this.goal_list_meta_without_deleted.forEach( goal => {
          let goal_meta = this.goal_meta_map[ goal.$id ];

          menu_goal_list.push({
            href:       '/goal/' + goal.$id + '/dashboard',
            name:        goal_meta.name,
            picture:     goal_meta.picture || '', // TODO
            goal_id:     goal.$id,
            category_id: goal.categoryId,
            selected:    this.active_goal === goal.$id,
            is_favorite: goal.isFavorite
          })
        });
      }
      return menu_goal_list
    },

    user_goal_settings() {
      return this.$models.userGoalSettings.subscribeList();
    },

    goal_meta_map() { // mixin!?
      /* Caching... */
      let goal_meta_map = {}
      for ( var goalSettingsId in this.user_goal_settings.items ) {
        if ( !goalSettingsId ) {
          continue
        }
        let goalMeta = this.$models.goalMeta.getNode( goalSettingsId );
        goal_meta_map[ goalSettingsId ] = goalMeta;
      }
      return goal_meta_map
    },

    goal_list_meta_without_deleted() {
      // return []; // < testing
      return this.user_goal_settings
        .itemsAsArray()
        .filter( item => !this.goal_meta_map[ item.$id ].deleted )
    },
  },
  methods: {

    onGoToGoal(goal_id) {
      this.$router.push('/goal/' + goal_id + '/dashboard')
    },

    onClickChevron() {
      this.collapsed = !this.collapsed;
    },

    onAddGoal() {
      this.$root.showNewModal('goal', { isTeamgoal: false });
    },

  },
  components: {
    InlineGoalMenubar,
  }
};
</script>
